import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-16px text-gray-lp-300 font-semibold font-montserrat" }
const _hoisted_2 = { class: "py-2 flex flex-row" }
const _hoisted_3 = { class: "w-full flex flex-row mt-4" }
const _hoisted_4 = {
  key: 0,
  class: "w-3/20"
}
const _hoisted_5 = { class: "pt-2" }
const _hoisted_6 = {
  key: 1,
  class: "w-3/20"
}
const _hoisted_7 = { class: "flex flex-col items-center justify-center" }
const _hoisted_8 = { class: "pt-2" }
const _hoisted_9 = {
  key: 2,
  class: "w-3/20"
}
const _hoisted_10 = { class: "pt-2" }
const _hoisted_11 = {
  key: 3,
  class: "w-3/20"
}
const _hoisted_12 = { class: "flex flex-col items-center justify-center" }
const _hoisted_13 = { class: "pt-2" }
const _hoisted_14 = {
  key: 4,
  class: "w-3/20"
}
const _hoisted_15 = { class: "pt-2 text-center" }
const _hoisted_16 = {
  key: 5,
  class: "w-3/20"
}
const _hoisted_17 = { class: "pt-2 text-center" }
const _hoisted_18 = {
  key: 6,
  class: "w-3/20"
}
const _hoisted_19 = { class: "pt-2" }
const _hoisted_20 = {
  key: 7,
  class: "w-1/12"
}
const _hoisted_21 = { class: "pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Pill = _resolveComponent("Pill")!
  const _component_ModalErrorBalance = _resolveComponent("ModalErrorBalance")!
  const _component_PPOBPopupModal = _resolveComponent("PPOBPopupModal")!
  const _component_ModalInstantBoookingConfirmation = _resolveComponent("ModalInstantBoookingConfirmation")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("dashboard.shortcut.menuUtama")), 1)
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.isCreateManualAbleV3)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", {
                class: 
            `py-2 ${
              !_ctx.validationAccount
                ? 'cursor-not-allowed text-black-lp-100'
                : 'cursor-pointer text-red-lp-300'
            } flex flex-col cursor-pointer items-center justify-center`
          ,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToCreateV3 && _ctx.goToCreateV3(...args)))
              }, [
                _createVNode(_component_Icons, { name: "shortcut-booking-manual" }),
                _createVNode("span", _hoisted_5, _toDisplayString(_ctx.accountType === "client"
                ? _ctx.$t("dashboard.shortcut.bookingKlien")
                : _ctx.$t("dashboard.shortcut.bookingRetail")), 1)
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isCreateManualAbleV4)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("div", {
                class: 
            `py-2 ${
              !_ctx.validationAccount
                ? 'cursor-not-allowed text-black-lp-100'
                : 'cursor-pointer text-red-lp-300'
            } flex flex-col cursor-pointer items-center justify-center`
          ,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToCreateV4 && _ctx.goToCreateV4(...args)))
              }, [
                _createVNode(_component_Icons, { name: "shortcut-booking-manual" }),
                _createVNode("div", _hoisted_7, [
                  _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("dashboard.shortcut.bookingRetail")), 1),
                  _createVNode(_component_Pill, {
                    text: _ctx.$t('dashboard.shortcut.new')
                  }, null, 8, ["text"])
                ])
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isCreateClientAbleV3)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode("div", {
                class: 
            `py-2 px-2 ${
              !_ctx.validationAccount
                ? 'cursor-not-allowed text-black-lp-100'
                : 'cursor-pointer text-red-lp-300'
            } flex flex-col cursor-pointer items-center justify-center`
          ,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToCreateClientV3 && _ctx.goToCreateClientV3(...args)))
              }, [
                _createVNode(_component_Icons, { name: "shortcut-booking-client" }),
                _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("dashboard.shortcut.bookingKlien")), 1)
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isCreateClientAbleV4)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode("div", {
                class: 
            `py-2 ${
              !_ctx.validationAccount
                ? 'cursor-not-allowed text-black-lp-100'
                : 'cursor-pointer text-red-lp-300'
            } flex flex-col cursor-pointer items-center justify-center`
          ,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToCreateClientV4 && _ctx.goToCreateClientV4(...args)))
              }, [
                _createVNode(_component_Icons, { name: "shortcut-booking-client" }),
                _createVNode("div", _hoisted_12, [
                  _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("dashboard.shortcut.bookingKlien")), 1),
                  _createVNode(_component_Pill, {
                    text: _ctx.$t('dashboard.shortcut.new')
                  }, null, 8, ["text"])
                ])
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAbleToCreateShipmentId)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _createVNode("div", {
                class: 
            `py-2 px-2 ${
              !_ctx.validationAccount
                ? 'cursor-not-allowed text-black-lp-100'
                : 'cursor-pointer text-red-lp-300'
            } flex flex-col cursor-pointer items-center justify-center`
          ,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goToCreateShipmentBook && _ctx.goToCreateShipmentBook(...args)))
              }, [
                _createVNode(_component_Icons, { name: "shortcut-booking-shipment" }),
                _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("dashboard.shortcut.bookingShipment")), 1)
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAbleToCreateShipmentV3)
          ? (_openBlock(), _createBlock("div", _hoisted_16, [
              _createVNode("div", {
                class: 
            `py-2 px-2 ${
              !_ctx.validationAccount
                ? 'cursor-not-allowed text-black-lp-100'
                : 'cursor-pointer text-red-lp-300'
            } flex flex-col cursor-pointer items-center justify-center`
          ,
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goToCreateShipmentBookV3 && _ctx.goToCreateShipmentBookV3(...args)))
              }, [
                _createVNode(_component_Icons, { name: "shortcut-booking-shipment" }),
                _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("dashboard.shortcut.bookingShipment")), 1),
                _createVNode(_component_Pill, {
                  text: _ctx.$t('dashboard.shortcut.new')
                }, null, 8, ["text"])
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAbleToCreateInstantBooking)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _createVNode("div", {
                class: 
            `py-2 px-2 ${
              !_ctx.validationAccount
                ? 'cursor-not-allowed  text-black-lp-100'
                : 'cursor-pointer  text-red-lp-300'
            } flex flex-col cursor-pointer items-center justify-center`
          ,
                onClick: _cache[7] || (_cache[7] = () => (_ctx.tncModal = true))
              }, [
                _createVNode(_component_Icons, { name: "shortcut-booking-instant" }),
                _createVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("dashboard.shortcut.bookingInstant")), 1)
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isPPOBVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_20, [
              _createVNode("div", {
                class: 
            `py-2 ${
              !_ctx.validationAccount
                ? 'cursor-not-allowed  text-black-lp-100'
                : 'cursor-pointer  text-red-lp-300'
            }
             flex flex-col items-center justify-center`
          ,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.togglePPOBDialog(true)))
              }, [
                _createVNode(_component_Icons, { name: "shortcut-booking-ppob" }),
                _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("dashboard.shortcut.ppob")), 1)
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ModalErrorBalance, {
      modelValue: _ctx.balanceUnderLimit,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.balanceUnderLimit = $event))
    }, null, 8, ["modelValue"]),
    (_ctx.ppobDialogModelValue)
      ? (_openBlock(), _createBlock(_component_PPOBPopupModal, {
          key: 0,
          modelValue: _ctx.ppobDialogModelValue,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.ppobDialogModelValue = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalInstantBoookingConfirmation, {
      isOpen: _ctx.tncModal,
      onClose: _ctx.onCloseTncModal,
      onAction: _ctx.goToInstantBooking
    }, null, 8, ["isOpen", "onClose", "onAction"])
  ], 64))
}